import React, { useState, useEffect } from 'react'
import { 
  Button, 
  Grid, 
  makeStyles,
  MenuItem,
} from '@material-ui/core'
import moment from 'moment';
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import { useForm } from '../../../../hooks/useForm';
import { useDispatch, useSelector } from 'react-redux';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ValidatedDatePicker from "../../../compartidos/ValidatedDatePicker";
import { ValidatorForm, SelectValidator } from 'react-material-ui-form-validator'
import { STEPPER_INTEGRACION_AUTO_G, TIPO_SOLICITUD_INTEGRACION } from '../../../Discapacidad/data/constants';
import { AutoCompleteEfectorFacturacion } from '../../../liquidaciones/UI/AutoCompleteEfectorFacturacion';
import { getSubTiposSolicitudesDiscapacidad, getTiposSolicitudesDiscapacidad } from '../../../../actions/discapacidad/discapacidadActions';
import { changeStepDiscapacidadAutoG, postSolicitudDiscapacidadAutoG, setSolicitudDiscapacidadAutoG } from '../../../../actions/webAfiliado/afiliadoDiscapacidadActions';
import { startAlerta } from '../../../../actions/ui/alertas';
import { getValidCertificadoIntegracion } from '../../../Discapacidad/Home/helperFunctions/ValidateCertificado';
import { TIPO_CERTIFICADOS } from '../../../../utils/constants';

const useStyles = makeStyles((theme) => ({
    buttons: {
      marginTop: "2rem",
      marginBottom: "1rem",
      display: "flex",
      justifyContent: "space-around"
    },
    container: {
      backgroundColor: "#fff", marginTop: "1rem"
    },
    autocomplete: {
      marginTop: 25,
      paddingLeft: 10,
      paddingRight: 10,
    },
    selects: {
      paddingRight: "1rem",
      paddingLeft: "1rem"
  }
}));

export const NuevaSolicStep2 = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch();
  const [certificadoVigente, setCertificadoVigente] = useState({});
  const { items: itemsCertificados } = useSelector((state) => state.certificadosAfiliacion);

  const {
    idAfiliado,
    disabled
  } = props

  const {
    tiposSolicitudes = [],
    subTiposSolicitudes = [],
  } = useSelector((state) => state.discapacidad);
  const {
    solicitudSeleccionada = {},
  } = useSelector((state) => state.afiliadoDiscapacidad);

  let solicitudDefault = {
    idSolicitud: "",
    fechaNacimiento: null,
    idTipoSolicitud: '',
    idSubTipoSolicitud: '',
    fechaDesde: null,
    fechaHasta: null,
    efectorProfesional: null,
  };

  const [
    formValues,
    handleInputChange,
    ,
    setearValor,
    ,
    ,
    ,
    ,
    setearVariosValores,
  ] = useForm(
    !!solicitudSeleccionada ? solicitudSeleccionada : solicitudDefault
  );

  const {
    fechaDesde,
    fechaHasta,
    idSolicitud,
    idTipoSolicitud,
    idSubTipoSolicitud,
  } = formValues;

  const [haveChangeValues, setHaveChangeValues] = useState(false);

  useEffect(() => {
    setCertificadoVigente(getValidCertificadoIntegracion(TIPO_CERTIFICADOS.DISCAPACIDAD, itemsCertificados));
  }, [itemsCertificados]);

  useEffect(() => {
    dispatch(getTiposSolicitudesDiscapacidad());
    dispatch(getSubTiposSolicitudesDiscapacidad());
  }, [dispatch]);

  //FechaDesde
  ValidatorForm.addValidationRule("isBeforeToday", (value) => {
    if (!moment(value).isValid() || moment(value).isBefore(moment(), "day")) {
      return false;
    }
    return true;
  });

  //FechaHasta
  ValidatorForm.addValidationRule("isAfterFechaDesde", (value) => {
    if (
      !moment(value).isValid() ||
      moment(value).isBefore(moment(fechaDesde), "day")
    ) {
      return false;
    }
    return true;
  });

  const checkCertificadoValido = () => {
    if (certificadoVigente.fechaVencimiento) {
      if (moment(fechaHasta).isAfter(certificadoVigente.fechaVencimiento, 'day'))
        if (!certificadoVigente.fecha2doVencimiento || moment(fechaHasta).isAfter(certificadoVigente.fecha2doVencimiento, 'day'))
          return false;
    } else {
      if (moment(fechaHasta).isAfter(certificadoVigente.fechaActualizacion, 'day'))
        return false;
    }
    return true;
  }

  const onSubmitHandler = () => {
    if (!checkCertificadoValido()) {
      dispatch(startAlerta("La fecha seleccionada es posterior a la fecha de vencimiento o actualización del certificado vigente. Debe contactarse con su centro.", "error"));
    } else {
      if (!haveChangeValues) {
        if (idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.ESCUELAS ||
          idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.HOGAR) {
          dispatch(changeStepDiscapacidadAutoG(STEPPER_INTEGRACION_AUTO_G.DIAGNOSTICO_DOCUMENTACION));
        } else {
          dispatch(changeStepDiscapacidadAutoG(STEPPER_INTEGRACION_AUTO_G.COMPLEMENTO_ORDEN));
        }
      } else {
        if (!solicitudSeleccionada?.idEfectorFacturacion) {
          dispatch(startAlerta("Debe seleccionar un Efector.", "error"));
        } else {
          const data = {
            ...solicitudSeleccionada,
            fechaDesde,
            fechaHasta,
            idAfiliado,
            idEfectorFacturacion: solicitudSeleccionada?.idEfectorFacturacion,
            efectorFacturacion: solicitudSeleccionada?.efectorFacturacion,
            idSolicitud,
            idTipoSolicitud,
            idSubTipoSolicitud,
          };

          dispatch(setSolicitudDiscapacidadAutoG(data));
          dispatch(postSolicitudDiscapacidadAutoG(
            { ...data, esAfiliado: true },
            (idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.ESCUELAS ||
              idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.HOGAR)
              ? STEPPER_INTEGRACION_AUTO_G.DIAGNOSTICO_DOCUMENTACION
              : STEPPER_INTEGRACION_AUTO_G.COMPLEMENTO_ORDEN
          )
          );
        }
      }
    }
  };

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} >
        <ValidatorForm onSubmit={onSubmitHandler}>
          <Grid container>
            <Grid item xs={12} md={6} className={classes.selects}>
              <SelectValidator
                fullWidth
                margin="normal"
                label="Tipo de Solicitud"
                name="idTipoSolicitud"
                value={idTipoSolicitud ?? ''}
                onChange={(e) => {
                  setearVariosValores({
                    idSubTipoSolicitud: '',
                    idTipoSolicitud: e.target.value,
                  });
                  setHaveChangeValues(true);
                }}
                disabled={disabled}
                validators={["required"]}
                errorMessages={["Este campo es requerido"]}
              >
                {tiposSolicitudes.map((tipoSolicitud) => (
                  <MenuItem
                    key={tipoSolicitud.idTipo}
                    value={tipoSolicitud.idTipo}
                  >
                    {tipoSolicitud.descripcion}
                  </MenuItem>

                ))}
              </SelectValidator>
            </Grid>
            <Grid item xs={12} md={6} className={classes.selects}>
              <SelectValidator
                fullWidth
                margin="normal"
                label="SubTipo de Solicitud"
                name="idSubTipoSolicitud"
                value={idSubTipoSolicitud ?? ''}
                onChange={(e) => {
                  if (e.target.value) {
                    handleInputChange(e);
                    setHaveChangeValues(true);
                  }
                }}
                disabled={disabled}
                validators={idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.HOGAR
                  ?
                  []
                  :
                  [
                    "required",
                  ]
                }
                errorMessages={["Este campo es requerido"]}
              >
                {idTipoSolicitud !== ''
                  ?
                  subTiposSolicitudes.filter(s => s.idTipo === idTipoSolicitud).map((item) => (
                    <MenuItem
                      key={item.idSubTipo}
                      value={item.idSubTipo}
                    >
                      {item.descripcion}
                    </MenuItem>
                  ))
                  :
                  <MenuItem></MenuItem>
                }
              </SelectValidator>
            </Grid>
            <Grid item xs={12} md={6} className={classes.selects}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <ValidatedDatePicker
                  fullWidth={true}
                  margin="normal"
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  label="Fecha Desde"
                  name="fechaDesde"
                  value={
                    fechaDesde !== undefined &&
                      moment(fechaDesde).isValid()
                      ? moment(fechaDesde)
                      : null
                  }
                  onChange={(e) => {
                    setHaveChangeValues(true);
                    setearValor("fechaDesde", e);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  minDate={new Date()}
                  disabled={disabled}
                  validators={disabled
                    ?
                    []
                    :
                    [
                      "required",
                      "isBeforeToday",
                    ]
                  }
                  errorMessages={
                    [
                      "La fecha desde es requerida",
                      "La fecha desde no puede ser menor a la fecha actual",
                    ]
                  }
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} md={6} className={classes.selects}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <ValidatedDatePicker
                  fullWidth={true}
                  margin="normal"
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  label="Fecha Hasta"
                  name="fechaPrescripcion"
                  value={
                    fechaHasta !== undefined &&
                      moment(fechaHasta).isValid()
                      ? moment(fechaHasta)
                      : null
                  }
                  onChange={(e) => {
                    setHaveChangeValues(true);
                    setearValor("fechaHasta", e);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  minDate={fechaDesde}
                  disabled={disabled}
                  validators={
                    [
                      "required",
                      "isAfterFechaDesde",
                    ]
                  }
                  errorMessages={
                    [
                      "La fecha hasta es requerida",
                      "La fecha hasta no puede ser menor a la fecha desde",
                    ]
                  }
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} className={classes.autocomplete}>
              <AutoCompleteEfectorFacturacion integracion={true} autogestion={true} disabled={disabled} />
            </Grid>
          </Grid>

          <div className={classes.buttons}>
            <Button
              type="button"
              variant="contained"
              color="secondary"
              style={{ textTransform: "none" }}
              onClick={() => {
                props.handleChangeStep(STEPPER_INTEGRACION_AUTO_G.BUSCAR_AFILIADO);
              }}
            >
              Anterior
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{ textTransform: "none" }}
            >
              Siguiente
            </Button>
          </div>
        </ValidatorForm>
      </Grid>
    </Grid>
  )
}

